import { Loader2, SearchX, Store } from 'lucide-react';

interface KitchenBoardStateProps {
  type: 'loading' | 'noBranch' | 'empty';
}

const KitchenBoardState = ({ type }: KitchenBoardStateProps) => {
  if (type === 'loading') {
    return (
      <div className="flex min-h-[400px] flex-col items-center justify-center gap-3 text-bodydark2">
        <Loader2 className="h-9 w-9 animate-spin text-primary" />
        Cargando comandas...
      </div>
    );
  }

  if (type === 'noBranch') {
    return (
      <div className="flex min-h-[400px] flex-col items-center justify-center text-center text-bodydark2">
        <Store className="mb-3 h-12 w-12 text-primary/40" />
        No hay una sucursal disponible.
      </div>
    );
  }

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center text-center">
      <span className="rounded-full bg-success/10 p-5 text-success">
        <SearchX className="h-10 w-10" />
      </span>

      <h2 className="mt-4 text-lg font-semibold text-black dark:text-white">
        No hay comandas para estos filtros
      </h2>

      <p className="mt-1 text-sm text-bodydark2">
        El tablero se actualizará automáticamente cuando lleguen nuevas órdenes.
      </p>
    </div>
  );
};

export default KitchenBoardState;
